import React from 'react';
import Hero from '../../components/Hero';
import imageBig from '../../assets/images/career-header-big.jpg';
import imageSmall from '../../assets/images/career-header-small.jpg';
import { Box } from '../../components/Layout';
import { List } from '../../components/Lists';
import colors from '../../utils/colors.js';
import Link from 'gatsby-link';

export default ({ data }) => {
  const { edges: vacancies } = data.allMarkdownRemark;
  return (
    <div>
      <Hero
        imageBig={imageBig}
        imageSmall={imageSmall}
      >
        <Box color='white' p={[3, 3, 4]} align='left'>
          <h1>Career</h1>
        </Box>
      </Hero>
      <Box 
        color={colors.black} 
        p={[3, 3, 4]}
        align='left'
      >
      <p>PCS is always hiring</p>
      <p>We teach people how to succed in high pressure envirnonments. If want to grow as a person and challenge yourself, think of a career at PCS.</p>
        <List>
          {vacancies.map(({node: vacancy}, index) => {
            return (
                <li key={index}>
                  <h1>
                    <Link to={vacancy.fields.slug}>
                      {vacancy.frontmatter.title}
                    </Link>
                  </h1>
                </li>
            )
          })}
        </List>
      </Box>
    </div>
  )
}

export const pageQuery = graphql`
  query VacanciesQuery {
    allMarkdownRemark (filter: { frontmatter: { category: { eq: "career" } }}){
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            category
            description
            date
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/career/index.js